var switchGridFuncs = 0, scrollTop = 0, checkScroll = true, lightbox = false, animating_filter = false, submitting = false, prijscalculator_filter = false, last_dropdown = '';

$ = jQuery;

(function(a) {
	(jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
})(navigator.userAgent || navigator.vendor || window.opera);

$(function() {
	mobileDevice = false;
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		mobileDevice = true;
	}
	if (jQuery.browser.mobile == true) {
		mobileDevice = true;
	}
	if (mobileDevice == true) {
		$('html').addClass('touchDevice');
	}

	init_activity_filter();
});

function init_activity_filter() {
	if ( $( '.activiteiten .overzicht' ).length > 0 ) {
		var month_filters = [];
		var items = $( '.items .item' );
		for ( var i = 0; i < items.length; i++ ) {
			if ( month_filters.indexOf( $( items[ i ] ).data( 'month' ) ) == -1 ) {
				month_str = $( items[ i ] ).data( 'month' );
				if ( month_str.indexOf( ',' ) > -1 ) {
					var month_array = month_str.split( "," );
					for ( var k = 0; k < month_array.length; k++ ) {
						if ( month_filters.indexOf( month_array[ k ] ) == -1 ) {
							month_filters.push( month_array[ k ] );
						}
					}
				} else {
					month_filters.push( month_str );
				}
			}
		}
		for ( var i = 0; i < month_filters.length; i++ ) {
			$( '.overzicht .filter ul li a[data-month="' + month_filters[ i ] + '"]' ).attr( 'data-hasevents', 'true' );
			//$( '.overzicht .filter ul' ).append( '<li><a href="#" data-month="' + month_filters[ i ] + '">' + month_filters[ i ].substr( 0, 3 ) + '</a></li>' );
		}
		$( '.overzicht .filter ul li a[data-hasevents="false"]' ).parent().remove();

		$( '.overzicht .filter ul li a' ).click( function(e) {
			e.preventDefault();
			$( '.overzicht .filter ul li a' ).removeClass( 'active' );
			$( this ).addClass( 'active' );
			do_activity_filter();
		});
		$( '.overzicht .filter ul li a' ).first().click();
	}
}

function do_activity_filter() {
	var	month = $( '.activiteiten .filter-selection ul a.active' ).data( 'month' );
	var	genre = $( '.activiteiten .filter-selection ul a.active' ).data( 'filter' );
	$( '.overzicht .items' ).animate( { opacity: 0 }, 500, function() {
		var total_shows = $( '.results .total span' ).text();
		if ( ( !month || month == '' ) && !genre || genre == '' ) {
			$( '.items a.item.filter_hidden' ).each(function() {
				$( this ).show( 500, function() { $( this ).animate( { 'opacity' : 1 }, 500 ) } ).removeClass( 'filter_hidden' );
				total_shows++;
				$( '.results .total span' ).text( total_shows );
			});
			$( '.overzicht .items' ).animate( { opacity: 1 } );
		} else {
			var total = 0;
			var counter = $( '.items a.item' ).length - 1;
			//var theater_counter = $( '.items a.item.theater' ).length - 1;
			//var film_counter = $( '.items a.item.item-film' ).length - 1;
			var h = 0;

			var $filter_selected = '',
					$filter_value = '';

			if ( 'undefined' != typeof month ) {
				$filter_selected = 'month';
				$filter_value = month;
			} else {
				$filter_selected = 'filter';
				$filter_value = genre;
			}

			$( '.items a.item' ).each(function() {
				show = false;
				keep = false;
				if ( $( this ).data( $filter_selected ).indexOf( $filter_value ) > -1 && $( this ).hasClass( 'filter_hidden' ) ) {
					//$( this ).show( 500, function() { $( this ).animate( { 'opacity' : 1 }, 500 ) } ).removeClass( 'filter_hidden' );
					$( this ).show().removeClass( 'filter_hidden' );;
					show = true;
					total++;
				} else if ( $( this ).data( $filter_selected ).indexOf( $filter_value ) > -1 ) {
					total++;
					keep = true;
				} else if ( $( this ).data( $filter_selected ).indexOf( $filter_value ) == -1 && !$( this ).hasClass( 'filter_hidden' ) ) {
					//$( this ).animate( { 'opacity' : 0 }, 500, function() { $( this ).hide( 500 ); } ).addClass( 'filter_hidden' );
					$( this ).hide().addClass( 'filter_hidden' );
					//total_shows--;
					$( '.results .total span' ).text( total_shows );
				}

				/*if ( ( total % 5 == 0 || total == 1 ) && ( show || keep ) ) {
					$( this ).addClass( 'first-theater-item' );
				} else {
					$( this ).removeClass( 'first-theater-item' );
				}*/
				if ( counter == h ) {
					var screen_test = $(window).width() < 1024;
					$( '.items a.item.theater,.items a.item.activity,.items a.item.zakelijk' ).removeClass( 'first-theater-item' );
					$('.items a.item.theater:not(.filter_hidden), .items a.item.activity:not(.filter_hidden), .items a.item.zakelijk:not(.filter_hidden)').filter(function (i) {
						if ( screen_test ) {
							return i % 2 + 1 == 1
						} else {
							return i % 3 + 1 == 1
						}
					}).addClass('first-theater-item');

					$( '.items a.item.item-film' ).removeClass( 'first-film-item' );
					$('.items a.item.item-film:not(.filter_hidden)').filter(function (i) {
						if ( screen_test ) {
							return i % 3 + 1 == 1
						} else {
							return i % 4 + 1 == 1
						}
					}).addClass('first-film-item');

					num_activities = $( '.items a.item.theater:not(.filter_hidden), .items a.item.activity:not(.filter_hidden), .items a.item.zakelijk:not(.filter_hidden)' ).length;
					$( '.results .total.total-activities span' ).text( num_activities );
					if ( num_activities == 0 ) {
						$( '.results .total.total-activities' ).animate( { opacity: 0 } );
					} else {
						$( '.results .total.total-activities' ).animate( { opacity: 1 } );
					}

					num_films = $( '.items a.item.item-film:not(.filter_hidden)' ).length;
					$( '.results .total.total-films span' ).text( num_films );
					if ( num_films == 0 ) {
						$( '.results .total.total-films' ).animate( { opacity: 0 } );
					} else {
						$( '.results .total.total-films' ).animate( { opacity: 1 } );
					}

					$( '.overzicht .items' ).animate( { opacity: 1 } );
				}
				h++;
				//$( '.results .total span' ).text( total );
			});
		}
	} );
}

/*
function helperFunctionSliced() {
	var $body = $('body'), themaClass = $('.wrap-inner').children('div').attr('class');

	if (themaClass != 'home') {
		$body.attr('data-theme', themaClass).addClass(themaClass);
		$('.ul-content li.' + themaClass).addClass('active');
	}
}*/

function hero() {
	var $hero = $('.home .hero');
	if ($hero.length > 0) {
		if (Modernizr.csstransitions) {
			$hero.addClass('css3');
		} else {
			// fallback older browsers
		}
		$hero.on( 'click', '.closed', function( e ) {
			e.preventDefault();
			var $this = $(this);
			$this.removeClass('closed').addClass('open').siblings('a').addClass('closed').removeClass('open');
		});
	}
}

var firstHero = true;
function resizeHero() {
	var $hero = $('.home .hero');
	if ($hero.length > 0) {
		var blockWidth = Math.ceil($hero.find('a.open').width());
		var blockHeight = Math.ceil($hero.find('a.open').height());
		$hero.find('.background img').css({
			'width' : blockWidth,
			'height' : 'auto'
		});
		var imgHeight = Math.ceil($hero.find('.background img').height());
		if (imgHeight < blockHeight) {
			$hero.find('.background img').css({
				'width' : 'auto',
				'height' : blockHeight
			});
			var marginTop = 0;
			$hero.find('.background img').css({
				'margin-top' : marginTop
			});
		} else {
			var marginTop = Math.abs((imgHeight - blockHeight) / 2) * -1;
			$hero.find('.background img').css({
				'margin-top' : marginTop
			});
		}
		if (firstHero == true) {
			firstHero = false;
			$hero.find('.left-block, .right-block').css({
				'opacity' : 1
			});
		}
	}
}

function share(){
	var share_background = $( '.share' ).css( 'background-image' );
	$( '.share_buttons' ).css( { visibility: 'hidden', height: 0, width: 0, overflow: 'hidden' } );
	$('.share').stop().on('click', function() {
		if ( !$('.share > a').hasClass('open') ) {
			$('.share > a').addClass('open');
			$( '.share' ).stop().css( { width: 190, height: 40 } );
			$( '.share_buttons' ).css( { height: 'auto', width: 'auto'} );
			$( '.share_buttons' ).stop().fadeIn( 800 );
		} else {
			$('.share > a').removeClass('open');
			$( '.share_buttons' ).stop().fadeOut( 800, function() {
				$( '.share' ).stop().css( { width: 20, height: 24, backgroundImage: share_background } );
			});
		}
	});
}

function themaLabels() {
	if ($('body').attr('data-theme').length > 0) {
		var bodyClass = $('body').attr('data-theme'), themaLabel = $('em', '#frame_right');
		themaLabel.text(bodyClass);
	}
}

function switchView() {

	if ($('.overzicht').length > 0 && $('.view').length > 0 && $('.items').length > 0) {

		// get class to set right button
		var viewClass = $('.items').attr('class').split(' ')[1];
		$('.view a.' + viewClass).removeClass('show').siblings('a').addClass('show');

		// als je op icoon klikt
		$('.view > a').on('click', function(e) {

			e.preventDefault();
			// get class
			var $this = $(this), thisClass = $this.attr('class').split(' ')[0], $items = $('.items'), $icon = $('.view a.' + thisClass);

			// change icoon
			$icon.removeClass('show');
			$icon.siblings('a').addClass('show');
			// fade resultaten uit
			$items.fadeOut('slow', function() {
				//on complete:
				// verander class
				if (thisClass == 'grid') {
					$items.removeClass();

					$items.addClass('items grid');
					if ($items.hasClass('grid')) {
						$items.fadeIn('slow');
					}
					$( '.items.grid a.item-grid' ).removeClass( 'first-film-item' );
					$('.items.grid a.item-grid:not(.filter_hidden)').filter(function (i) {
					  return i % 4 + 1 == 1
					}).addClass('first-film-item');

				} else if (thisClass == 'list') {
					$items.removeClass();
					$items.addClass('items list');

					if ($items.hasClass('list')) {
						$items.fadeIn('slow');
					}
				}
			});
		});
	}
}

function openTopNav() {
	var $topnav = $('.top-nav'), $ul = $('ul', '.top-nav'), $tel = $topnav.find('.tel'), ulWidth = 40, btnWidth =  $('.open', '.hamburger-menu').width();

	// count width ul
	$ul.find('li').each(function() {
		ulWidth += Math.ceil($(this).outerWidth(true)) + 24;
	});

	// place ul to right of window
	$ul.css({'right': -ulWidth});

	// OPEN
	$('.open', '.hamburger-menu').on('click', function() {
		var $this = $(this);

		// fadeOut telefoonnummer
		$tel.addClass('hide');
		$this.fadeOut(500);

		// change width of ul
		setTimeout(function() {
			$ul.css({
				'right' : btnWidth + 24,
				'opacity' : 1
			});
			$tel.hide();

		}, 500);

		// hamburger icon turns in to close button
		setTimeout(function() {
			$this.next('.close').fadeIn().addClass('show');
		}, 500);
	});

	// CLOSE
	$('.close', '.hamburger-menu').on('click', function() {
		var $this = $(this), $open = $this.prev('.open');

		// change width of ul
		setTimeout(function() {
			$ul.css({
				'right' : -ulWidth,
				'opacity' : 0
			});
			$tel.hide();
		}, 500);

		// close button turns into hamburger icon
		setTimeout(function() {
			$this.fadeOut(300).addClass('hide');
			$open.removeClass('hide').fadeIn(300);
		}, 500);

		// fadeIn telefoonnummer
		setTimeout(function() {
			$tel.removeClass('hide').show();
		}, 1200);
	});

}

function makeAsideSticky() {
	if ($('.detail').length > 0) {
		var $aside = $('aside');

		if ($aside.length > 0) {

			var docViewTop = $(window).scrollTop(),
				heightHeader = $('.top-nav').height() + $('header').height(),
				contentTop = $('.content').offset().top;

			var asideTop = 0;
			if ( $aside.length > 0 ) {
				asideTop = $aside.offset().top - heightHeader;
			}

			if (docViewTop >= 60) {
				$aside.css({
					'position' : 'fixed',
					'top' : heightHeader
				});
			} else {
				$aside.css({
					'position' : 'absolute',
					'top' : 60
				});
			}
		}
	}
}

function openSearchFilter() {
	var $filterSlidedUp = $('.filter-slided-up'),
		$closeButton = $filterSlidedUp.find('.close-trefwoord'),
		centerWidth = $filterSlidedUp.parents('.center').width(),
		closeButtonWidth = $closeButton.outerWidth();

	// OPEN
	$filterSlidedUp.find('.icon-search').on('click', slideSearchOpen);
	$filterSlidedUp.find('input.trefwoord').focus(slideSearchOpen);

	function slideSearchOpen() {
		if (animating_filter === false) {
			animating_filter = true;
			$filterSlidedUp.find('em').addClass('hide');
			$filterSlidedUp.find('button, .button').addClass('hide');
			setTimeout(function() {
				$('.input-trefwoord').css({
					'width' : centerWidth - closeButtonWidth - 12
				}).addClass('wide');
			}, 300);
			setTimeout(function() {
				$closeButton.css({
					'opacity' : 1
				});
				animating_filter = false;
			}, 500);
		}
	}

	// CLOSE
	$closeButton.on('click', function(e) {
		e.preventDefault();
		if (animating_filter === false) {
			animating_filter = true;
			setTimeout(function() {
				$('.input-trefwoord').css({
					'width' : '48%'
				}).removeClass('wide');
				$closeButton.css({
					'opacity' : 0
				});
			}, 1);
			setTimeout(function() {
				$filterSlidedUp.find('em').removeClass('hide');
				$filterSlidedUp.find('button, .button').removeClass('hide');
				animating_filter = false;
			}, 500);
		}
	});
}

function openSearchMenu() {

	var $nav = $('header nav'),
		$input = $nav.find('.input-search'),
		widthInput = $nav.find('ul').width() - 24,
		$closeButton = $nav.find('.close-search');

	$nav.find('.search .icon-search').on('click', function(e) {

		e.preventDefault();

		// hide all items
		$nav.find('li').each(function() {
			var $this = $(this);
			if ($this.hasClass('search')) {
				$this.find('.icon-search').addClass('hide');

			} else {
				$this.addClass('hide');
			}
		});

		// show close button & input
		$closeButton.css({
			'opacity' : 1,
			'z-index' : 8
		});
		$input.find('.icon').fadeIn();
		$input.css({
			'opacity' : 1,
			'width' : widthInput
		});
		setTimeout(function() {
			$input.find('input').focus();
		}, 500);
	});

	$closeButton.on('click', function() {
		$closeButton.css({
			'opacity' : 0,
			'z-index' : 6
		});
		$input.find('.icon').fadeOut();
		$input.css({
			'width' : 0,
			'opacity' : 0
		});
		$nav.find('li').each(function() {
			var $this = $(this);
			if ($this.hasClass('search')) {
				$this.find('.icon-search').removeClass('hide');

			} else {
				$this.removeClass('hide');
			}
		});
	});
}

function openSearchMenuMobile() {

	var $nav = $('header nav'), $input = $nav.find('.input-search'), widthInput = 210, $closeButton = $nav.find('.close-search');

	$nav.find('.mobile-nav-icon .icon-search').on('click', function(e) {

		e.preventDefault();

		// hide logo
		$('.logo').fadeOut();

		// hide search icon
		$(this).fadeOut();

		// show close button & input
		$closeButton.css({
			'opacity' : 1,
			'z-index' : 8
		});
		$input.css({
			'opacity' : 1,
			'width' : widthInput
		}).children('input').focus();

	});

	$closeButton.on('click', function() {
		$closeButton.css({
			'opacity' : 0,
			'z-index' : 6
		});
		$input.css({
			'width' : 0
		});
		// show logo
		$('.logo').fadeIn();

		// show search icon
		$('.mobile-nav-icon .icon-search').fadeIn();
	});
}

function openCloseFilter() {

	if ($('.filter-slided-down').length > 0) {

		var $filter = $('.filter'), $filterSlidedDown = $('.filter-slided-down'), $filterSlidedUp = $('.filter-slided-up');

		$filter.css({
			'height' : $filterSlidedDown.height()
		}).css({
			'height' : $filterSlidedUp.height() + 75
		});

		// OPEN
		$('.filter button, .filter .button', '.overzicht').on('click', function() {

			// add class to hide first div
			$filterSlidedUp.addClass('hide').removeClass('show');
			// increase height of filterDiv
			$filterSlidedDown.show();
			$filter.css({
				'height' : $filterSlidedDown.outerHeight()
			});
			setTimeout(function() {
				// add class to show second div
				$filterSlidedDown.addClass('show').removeClass('hide');
			}, 1);
			return false;
		});

		// CLOSE
		$filterSlidedDown.find('.close').on('click', function() {
			$filterSlidedDown.addClass('hide').removeClass('show');
			$filter.css({
				'height' : $filterSlidedUp.height() + 75
			});
			setTimeout(function() {
				$filterSlidedUp.addClass('show').removeClass('hide');
			}, 1);
			setTimeout(function() {
				$filterSlidedDown.hide();
			}, 500);
			return false;
		});

		checkOpenCourseFilter();
	}
}

function selectFilterButton() {
	if ($('.cursussen .filter-buttons').length > 0) {
		$('.cursussen .filter-buttons button, .cursussen .filter-buttons .button').each(function() {
			var $this = $(this);
			$this.on('click', function(e) {
				e.preventDefault();
				$this.addClass('active');
				$(this).siblings('button, .button').removeClass('active');
			});
		});
	}
}

function selectWelzijnFilter() {
	if ( $( '.filter' ).length > 0 ) {
		$( 'button, .button', '.welzijn .filter-buttons,.zakelijk .filter-buttons' ).on( 'click', function(e) {
			e.preventDefault();
			var $this = $(this);
			if ( $this.hasClass( 'active' ) ) {
				$this.removeClass('active');
			} else {
				$this.addClass('active');
			}
			var type = $this.is('.active') ? $this.data('value') : '';
			$this.closest('.filter').find('button[data-value!="' + type + '"]').removeClass('active');

			var total_shows = $( '.results .total span' ).text();
			$( '.results .total' ).removeClass('multi');
			if ( typeof type == 'undefined' || !type || type == '' ) {
				$( '.items a.item.filter_hidden' ).each(function() {
					$( this ).show( 500, function() { $( this ).animate( { 'opacity' : 1 }, 500 ) } ).removeClass( 'filter_hidden' );
					total_shows++;
					$( '.results .total span' ).text( total_shows );
				});
			} else {
				type = type.toLowerCase();

				var total = 0,
					filtername = typeof $this.data('filter') != 'undefined' ? $this.data('filter') : 'activiteiten';

				$( '.items a.item' ).each(function() {
					show = false;
					keep = false;
					//console.log($( this ).data( filtername ).indexOf( type ));
					if ( typeof $( this ).data( filtername ) == 'undefined' ) {
						$( this ).animate( { 'opacity' : 0 }, 500, function() { $( this ).hide( 500 ); } ).addClass( 'filter_hidden' );
						//total_shows--;
						$( '.results .total span' ).text( total_shows );
					} else if ( $( this ).data( filtername ).indexOf( type ) > -1 && $( this ).hasClass( 'filter_hidden' ) ) {
						$( this ).show( 500, function() { $( this ).animate( { 'opacity' : 1 }, 500 ) } ).removeClass( 'filter_hidden' );
						//total_shows++;
						show = true;
						total++;
						//$( '.results .total span' ).text( total_shows );
					} else if ( $( this ).data( filtername ).indexOf( type ) > -1 ) {
						total++;
						keep = true;
					} else if ( $( this ).data( filtername ).indexOf( type ) == -1 && !$( this ).hasClass( 'filter_hidden' ) ) {
						$( this ).animate( { 'opacity' : 0 }, 500, function() { $( this ).hide( 500 ); } ).addClass( 'filter_hidden' );
						//total_shows--;
						$( '.results .total span' ).text( total_shows );
					}
					if ( ( ( ( total-1 ) % 3 ) + 1 == 1 ) && ( show || keep ) ) {
						$( this ).addClass( 'first-welzijn-item' );
					} else {
						$( this ).removeClass( 'first-welzijn-item' );
					}

					if( total > 1 || total == 0 ) {
						$( '.results .total' ).addClass('multi');
					}

					$( '.results .total span' ).text( total );
				});
			}
		});
	}
}

function selectTheaterFilter() {
	if ( $( '.filter' ).length > 0 ) {
		$( 'a', '.theater .filter-selection ul' ).on( 'click', function(e) {
			e.preventDefault();
			var $this = $(this);

			if ($(this).parents('.days').length > 0) {
				$this.toggleClass('active');
				do_movie_days_filter();
			} else {
				if ($(this).hasClass('active')) {
					$this.removeClass('active');
				} else {
					$this.addClass('active');
					$(this).parent('li').siblings().children('a').removeClass('active');
				}
				do_genre_filter();
			}
		});
	}
}

function selectFilmFilter() {
	num_flavour = $( '.film .results .items .item[data-special*="flavour-film"]' ).length;
	num_ladies = $( '.film .results .items .item[data-special*="ladies-night"]' ).length;
	num_ontbijt = $( '.film .results .items .item[data-special*="filmontbijt"]' ).length;
	if ( num_flavour > 0 || num_ladies > 0 ) {
		$( '.special-filter' ).show();
		if ( num_ladies > 0 ) {
			$( '.ladies-night-filter' ).show();
		}
		if ( num_flavour > 0 ) {
			$( '.flavour-film-filter' ).show();
		}
		if ( num_ontbijt > 0 ) {
			$( '.filmontbijt-filter' ).show();
		}
	}
	$( '.film .filter .days li' ).each( function() {
		var day = $( 'a', this ).text().toLowerCase();
		var num_movies = $( '.film .results .items .item[data-days*="' + day + '"]' ).length;
		if ( num_movies > 0 ) {
			$( this ).removeClass( 'inactive' );
		}
	});
	$( '.film .filter .period-filter li' ).each( function() {
		var period = $( 'a', this ).data('filter').toLowerCase();
		var num_movies = $( '.film .results .items .item[data-period*="' + period + '"]' ).length;
		if ( num_movies > 0 ) {
			$( this ).removeClass( 'inactive' );
		}
	});

	if ( $( '.filter' ).length > 0 ) {
		$( 'a', '.film .filter-selection ul li:not(.inactive)' ).on( 'click', function(e) {
			e.preventDefault();
			var $this = $(this);

			if ( $(this).parents('.days').length > 0 ) {
				$this.toggleClass('active');
			} else {
				if ($(this).hasClass('active')) {
					$this.removeClass('active');
				} else {
					$this.addClass('active');
					$(this).parent('li').siblings().children('a').removeClass('active');
				}
			}
			do_movie_filter();
		});
	}
}

function do_genre_filter() {
	genre = $( '.theater .filter-selection ul a.active' ).text().toLowerCase();
	var total_shows = $( '.results .total span' ).text();
	if ( !genre || genre == '' ) {
		$( '.items a.item.filter_hidden' ).each(function() {
			$( this ).show( 500, function() { $( this ).animate( { 'opacity' : 1 }, 500 ) } ).removeClass( 'filter_hidden' );
			total_shows++;
			$( '.results .total span' ).text( total_shows );
		});
	} else {
		var total = 0;
		$( '.items a.item' ).each(function() {
			show = false;
			keep = false;
			if ( $( this ).data( 'genres' ).indexOf( genre ) > -1 && $( this ).hasClass( 'filter_hidden' ) ) {
				$( this ).show( 500, function() { $( this ).animate( { 'opacity' : 1 }, 500 ) } ).removeClass( 'filter_hidden' );
				//total_shows++;
				show = true;
				total++;
				//$( '.results .total span' ).text( total_shows );
			} else if ( $( this ).data( 'genres' ).indexOf( genre ) > -1 ) {
				total++;
				keep = true;
			} else if ( $( this ).data( 'genres' ).indexOf( genre ) == -1 && !$( this ).hasClass( 'filter_hidden' ) ) {
				$( this ).animate( { 'opacity' : 0 }, 500, function() { $( this ).hide( 500 ); } ).addClass( 'filter_hidden' );
				//total_shows--;
				$( '.results .total span' ).text( total_shows );
			}

			if ( ( total % 5 == 0 || total == 1 ) && ( show || keep ) ) {
				$( this ).addClass( 'first-theater-item' );
			} else {
				$( this ).removeClass( 'first-theater-item' );
			}
			$( '.results .total span' ).text( total );
		});
	}
}

function do_movie_filter() {
	var period = '';
	if ( $( '.film .filter-selection .period-filter ul a.active' ).length > 0 ) {
		period = $( '.film .filter-selection .period-filter ul a.active' ).data( 'filter' );
	}
	day_prefix = '';
	if ( period == 'expected' ) {
		$( '.film .filter-selection .days ul a.active' ).removeClass( 'active' );
	} else if ( period == 'next-week' ) {
		day_prefix = 'nw-';
	} else if ( period == 'this-week' ) {
		day_prefix = 'tw-';
	}

	var days = [];
	var active_days = $( '.film .filter-selection .days ul a.active' );
	for ( var i = 0; i < active_days.length; i++ ) {
		days.push( day_prefix + $( active_days[ i ] ).text().toLowerCase() );
	}

	var special = '';
	if ( $( '.film .filter-selection .special-filter ul a.active' ).length > 0 ) {
		special = $( '.film .filter-selection .special-filter ul a.active' ).data( 'filter' );
	}

	$('.items').animate({'opacity' : 0}, 500, function() {
		var total = 0; //$( '.results .total span' ).text();
		var counter = $( '.items a.item' ).length - 1;
		var h = 0;
		$( '.items a.item' ).each(function() {
			show = false;
			hide = false;
			keep = false;
			if ( days.length > 0 ) {
				for ( var i = 0; i < days.length; i++ ) {
					if ( $( this ).data( 'days' ).indexOf( days[ i ] ) > -1 && $( this ).hasClass( 'filter_hidden' ) ) {
						show = true;
					} else if ( $( this ).data( 'days' ).indexOf( days[ i ] ) == -1 && !$( this ).hasClass( 'filter_hidden' ) ) {
						hide = true;
					} else if ( $( this ).data( 'days' ).indexOf( days[ i ] ) > -1 ) {
						keep = true;
					}
				}
			} else if ( $( this ).hasClass( 'filter_hidden' ) ) {
				show = true;
			} else {
				keep = true;
			}

			if ( special != '' && $( this ).data( 'special' ).indexOf( special ) == -1 && ( show || keep ) ) {
				show = false;
				keep = false;
				hide = true;
			}
			if ( period != '' && $( this ).data( 'period' ).indexOf( period ) == -1 && ( show || keep ) ) {
				show = false;
				keep = false;
				hide = true;
			}

			if ( show == true ) {
				// $( this ).show( 500, function() { $( this ).animate( { 'opacity' : 1 }, 500 ) } ).removeClass( 'filter_hidden' );
				$(this).show().removeClass( 'filter_hidden' );
				total++;
				$( '.results .total span' ).text( total );
			} else if ( hide == true && !keep ) {
				//$( this ).animate( { 'opacity' : 0 }, 500, function() { $( this ).hide( 500 ); } ).addClass( 'filter_hidden' );
				$(this).hide().addClass( 'filter_hidden' );
			} else if ( keep == true ) {
				total++;
			}

			if ( counter == h ) {
				var screen_test = $(window).width() < 1024;
				$( '.items.grid a.item-grid' ).removeClass( 'first-film-item' );
				$('.items.grid a.item-grid:not(.filter_hidden)').filter(function (i) {
					return i % 4 + 1 == 1
				}).addClass('first-film-item');
				$( '.results .total span' ).text( $( '.items a.item:not(.filter_hidden)' ).length );
				$('.items').animate({'opacity' : 1}, 500);
			}
			h++;
		});
	});
}

function do_movie_days_filter() {
	var days = [];
	var active_days = $( '.film .filter-selection .days ul a.active' );
	for ( var i = 0; i < active_days.length; i++ ) {
		days.push( $( active_days[ i ] ).text().toLowerCase() );
	}
	var total = $( '.results .total span' ).text();

	if ( days.length == 0 ) {
		$( '.items a.item.filter_hidden' ).each(function() {
			$( this ).show( 500, function() { $( this ).animate( { 'opacity' : 1 }, 500 ) } ).removeClass( 'filter_hidden' );
			total++;
			$( '.results .total span' ).text( total );
		});
	} else {
		$( '.items a.item' ).each(function() {
			show = false;
			hide = false;
			keep = false;


			for ( var i = 0; i < days.length; i++ ) {
				if ( $( this ).data( 'days' ).indexOf( days[ i ] ) > -1 && $( this ).hasClass( 'filter_hidden' ) ) {
					show = true;
				} else if ( $( this ).data( 'days' ).indexOf( days[ i ] ) == -1 && !$( this ).hasClass( 'filter_hidden' ) ) {
					hide = true;
				} else if ( $( this ).data( 'days' ).indexOf( days[ i ] ) > -1 ) {
					keep = true;
				}
			}

			if ( show == true ) {
				$( this ).show( 500, function() { $( this ).animate( { 'opacity' : 1 }, 500 ) } ).removeClass( 'filter_hidden' );
				total++;
				$( '.results .total span' ).text( total );
			} else if ( hide == true && !keep ) {
				$( this ).animate( { 'opacity' : 0 }, 500, function() { $( this ).hide( 500 ); } ).addClass( 'filter_hidden' );
				total--;
				$( '.results .total span' ).text( total );
			}
		});
	}
}


function positionBgImg() {
	if ($('.detail').length > 0) {
		var $bottom = $('.bottom', '.detail');
		// if bottom is in view:

		if ($bottom.length > 0)
			if (isScrolledIntoView($bottom, 0)) {
				var topValue = $('.top').height() - $(window).height() + 55;

				var leftRightValue = -40;

				if ($('html').hasClass('landscape')) {
					leftRightValue = 0;
				}

				$('.bg-image').css({
					'position' : 'absolute',
					'left' : leftRightValue,
					'right' : leftRightValue,
					'top' : topValue,
					'height' : $(window).height(),
					'width' : $(window).width()
				});

				// if bottom is out of view:
			} else {
				$('.bg-image').css({
					'position' : 'fixed',
					'left' : 0,
					'right' : 0,
					'top' : 0,
					'height' : '100%',
					'width' : '100%'
				});
			}

		if ($('.bg-image img').height() > 0 && ($('.bg-image img').height() < $('.bg-image').height()))
			$('.bg-image > img').css({
				'height' : '100%',
				'width' : 'auto'
			});

	}
}

function isScrolledIntoView(elem, addedLength) {
	var $elem = $(elem), $window = $(window), docViewTop = $window.scrollTop(), docViewBottom = docViewTop + $window.height(), elemTop = $elem.offset().top - addedLength;
	return ((elemTop <= docViewBottom));
}

// function moreInfo() {
// 	var $block = $('.info-block', '.detail'),
// 		$blockTop = $('.info-block-top', '.detail'),
// 		$blockBottom = $('.info-block-bottom', '.detail'),
// 		blockBottomHeight = $blockBottom.children('.info-block-inner').outerHeight(true);

// 	$('.more-info a', '.detail').on('click', function(e) {

// 		e.preventDefault();
// 		var $this = $(this);
// 		//console.log($this);
// 		$this.addClass('hidden').siblings('a').removeClass('hidden');

// 		if ($this.parent('div').hasClass('open')) {
// 			setTimeout(function() {
// 				$this.parent('div').removeClass('open');
// 				$blockBottom.outerHeight(0);
// 				$blockBottom.children('.info-block-inner').css({
// 					'opacity' : 0
// 				});
// 			}, 1);
// 		} else {
// 			setTimeout(function() {
// 				$this.parent('div').addClass('open');
// 				$blockBottom.outerHeight(blockBottomHeight);
// 				$blockBottom.children('.info-block-inner').css({
// 					'opacity' : 1
// 				});
// 			}, 1);
// 		}
// 		return false;
// 	});

// }

function showPaymentFields() {

	// if on form page:
	if ($('.content').hasClass('form')) {

		$('.soorten ul', '.content.form').each(function() {
			var $this = $(this);
			var $form = $this.closest('form');
			$.ajax({
				type : 'POST',
				url : js_object.ajax_url,
				data : {
					'action' : 'form-prices',
					'id' : $form.find('input[name="post_id"]').val(),
					'discipline' : $form.find('input[name="discipline"]').val()
				},
				success : function(data) {

					var obj = JSON.parse(data);

					if (obj.html != '') {
						$this.html(obj.html);
					}
				}
			});
		});

		// if checkbox is clicked and checked:
		var $checkbox = $('input[type="checkbox"]', '.no-pay'), $paymentFields = $('.info-payer'), innerHeight = $paymentFields.find('.info-payer-inner').outerHeight() + 20;

		$('.icon', '.content.form:not(".form--klacht")').each(function() {
			var box = this;
			if ($(this).data('id') != undefined) {
				var iconId = $(this).data('id');
				initIcon(box, iconId);
			}
		});

		$checkbox.on('click', function() {
			if ($checkbox.is(':checked')) {
				$paymentFields.css({
					'height' : innerHeight,
					'opacity' : 1
				});
			} else {
				$paymentFields.css({
					'height' : 0,
					'opacity' : 0
				});
			}
		});
	}
}

function checkIbanRequired() {
	var $field = $('.content form .input.iban');

	if ( $('.content').hasClass('form') && $field.length > 0 ) {
		$('.content form input[name="betaling"]').change(function(){
			var $current = $(this).val();
			if ( 'factuur ontvangen' == $current.toLowerCase() || 'pas van dronten' == $current.toLowerCase() ) {
				$field.css('opacity',0);
			} else {
				$field.css('opacity',1);
			}
		});
	}
}

function owl() {
	$("#owl").owlCarousel({
		navigation : false,
		slideSpeed : 300,
		paginationSpeed : 400,
		singleItem : true,
		autoPlay : false,
		pagination : true,
		responsive : true,
		touchDrag : true
	});
}

function tellafriend() {
	var $btn = $('.tellafriend');

	$btn.on('click', function(e) {
		e.preventDefault();
		if ($(this).data('id') == '')
			return false;

		$('#lightbox_overlay_taf').stop().show().animate({
			'opacity' : 1
		}, 500);

		//console.log($(this).data('id'));

		$.ajax({
			url : js_object.template_dir + '/includes/ajax/tell-a-friend.php',
			data : {
				'id' : $(this).data('id'),
				'url': js_object.current_url,
			}
		}).done(function(data) {
			if ($(window).width() >= 768) {

				$('#lightbox_taf .box').html(data).css({'width': '360px', 'background': 'transparent'});

			} else {
				$('#lightbox_taf .box').html(data).css({'width': '280px', 'background': 'transparent'});
			}

			$('#lightbox_taf').css({'top': '0', 'opacity': 1}).show();
			$('.icon', '.tell-a-friend').each(function() {
				var box = this;
				if ($(this).data('id') != undefined) {
					var iconId = $(this).data('id');
					initIcon(box, iconId);
				}
			});


			$('.tell-a-friend form').submit(function(e) {
				e.preventDefault();
				if ( !submitting ) {
					$('.tell-a-friend form .message').remove();
					$('.tell-a-friend form .error-style').removeClass( 'error-style' );
					submitting = true;
					$.ajax({
						type : 'POST',
						url : js_object.ajax_url,
						data : $(this).serialize(),
						success : function(data) {
							submitting = false;

							if ( data === 'true' ) {
								$('.tell-a-friend form .submit').html('<div class="message">succesvol verzonden!</div>').find('.message').animate({
									'opacity' : '1'
								}, 500, function() {
									setTimeout(function() {
										$('#lightbox .close_btn').trigger('click');
									}, 1500);
								});
							} else {
								var obj = JSON.parse(data);
								if (obj.errors) {
									for ( field in obj.errors ) {
										$('.tell-a-friend form input[name="' + obj.errors[field] + '"],.tell-a-friend form div[id="' + obj.errors[field] + '"],.tell-a-friend form textarea[name="' + obj.errors[field] + '"],.tell-a-friend form label[for="' + obj.errors[field] + '"]').addClass('error-style');
										if ( obj.errors[field] == 'captcha' ) {
											$('.tell-a-friend form .g-recaptcha').after('<div class="message">Vink het veld "Ik ben geen robot" aan.</div>').find('.message').animate({
												'opacity' : '1'
											}, 500 );
											grecaptcha.reset();
										}
									}
									$('.tell-a-friend form .submit').prepend('<div class="message">mislukt, controleer het formulier!</div>').find('.message').animate({
										'opacity' : '1'
									}, 500, function() {
										setTimeout(function() {
											$('.tell-a-friend form .submit .message').animate({
												'opacity' : '0'
											}, 500, function() {
												$(this).remove();
											});
										}, 1500);
									});
								}
								/*} else if (data == 'true') {
									$('.tell-a-friend form .submit').html('<div class="message">succesvol verzonden!</div>').find('.message').animate({
										'opacity' : '1'
									}, 500, function() {
										setTimeout(function() {
											$('#lightbox .close_btn').trigger('click');
										}, 1500);
									});
								}*/
							}
						},
						error : function(e) {
							submitting = false;
						}
					});
				}
			});
		});
		$('#lightbox_taf').on('click', '.close_btn', function() {
			$('#lightbox_overlay_taf').stop().animate({
				'opacity' : 0
			}, 500, function() {
				$(this).hide();
			});
			$('#lightbox_taf').animate({
				'opacity' : 0
			}, 500, function() {
				$(this).hide();
			});
		});
	});
}

var scrollTop, checkScroll, lightbox;

function newsletter_subscribe() {
	var $btn = $('.newsletter-subscribe-btn');

	$btn.on('click', function(e) {
		e.preventDefault();

		window.open("https://meerpaal.crmplatform.nl/aanmelden-nieuwsbrief", "_blank");

		// if ($(this).data('id') == '')
		// 	return false;


		// scrollTop = $(window).scrollTop();
		// checkScroll = false;
		// lightbox = true;
		// $('#wrap').addClass('sticked').css({
		// 	'top' : scrollTop - (2 * scrollTop)
		// });

		// $('#lightbox_overlay_taf').stop().show().animate({
		// 	'opacity' : 1
		// }, 500);

		$('.newsletter-message').hide();
		//console.log($(this).data('id'));

		// $.ajax({
		// 	url : js_object.template_dir + '/includes/ajax/newsletter-subscribe.php',
		// }).done(function(data) {
		// 	if ($(window).width() >= 768) {

		// 		$('#lightbox_taf .box').html(data).css({'width': '360px', 'background': 'transparent'});

		// 	} else {
		// 		$('#lightbox_taf .box').html(data).css({'width': '280px', 'background': 'transparent'});
		// 	}

		// 	$('#lightbox_taf').css({'opacity': 1}).show();
		// 	$('.icon', '.newsletter-subscribe').each(function() {
		// 		var box = this;
		// 		if ($(this).data('id') != undefined) {
		// 			var iconId = $(this).data('id');
		// 			initIcon(box, iconId);
		// 		}
		// 	});


		// 	$('.newsletter-subscribe form').submit(function(e) {
		// 		e.preventDefault();
		// 		if ( !submitting ) {
		// 			$('.newsletter-subscribe form .message').remove();
		// 			$('.newsletter-subscribe form .error-style').removeClass( 'error-style' );
		// 			submitting = true;
		// 			$.ajax({
		// 				type : 'POST',
		// 				url : js_object.ajax_url,
		// 				data : $(this).serialize(),
		// 				success : function(data) {
		// 					submitting = false;

		// 					if ( data === 'true' ) {
		// 						$('.newsletter-subscribe form .submit').html('<div class="message">succesvol verzonden!</div>').find('.message').animate({
		// 							'opacity' : '1'
		// 						}, 500, function() {
		// 							setTimeout(function() {
		// 								$('#lightbox .close_btn').trigger('click');
		// 							}, 1500);
		// 						});
		// 						var date = new Date();
		// 						date.setTime(date.getTime()+(100*24*60*60*1000));
		// 						var expires = "; expires="+date.toGMTString();
		// 						document.cookie = 'newsletter=yes'+expires+'; path=/'
		// 					} else {
		// 						var obj = JSON.parse(data);
		// 						if (obj.errors) {
		// 							for ( field in obj.errors ) {
		// 								$('.newsletter-subscribe form input[name="' + obj.errors[field] + '"],.newsletter-subscribe form div[id="' + obj.errors[field] + '"],.newsletter-subscribe form textarea[name="' + obj.errors[field] + '"],.newsletter-subscribe form label[for="' + obj.errors[field] + '"]').addClass('error-style');
		// 								if ( obj.errors[field] == 'groups' ) {
		// 									$('.newsletter-subscribe form .groups-label').addClass('error-style');
		// 								}
		// 							}
		// 							$('.newsletter-subscribe form .submit').prepend('<div class="message">mislukt, controleer het formulier!</div>').find('.message').animate({
		// 								'opacity' : '1'
		// 							}, 500, function() {
		// 								setTimeout(function() {
		// 									$('.newsletter-subscribe form .submit .message').animate({
		// 										'opacity' : '0'
		// 									}, 500, function() {
		// 										$(this).remove();
		// 									});
		// 								}, 1500);
		// 							});
		// 						}
		// 					}
		// 				},
		// 				error : function(e) {
		// 					submitting = false;
		// 				}
		// 			});
		// 		}
		// 	});
		// });
		// $('#lightbox_taf').on('click', '.close_btn', function( e ) {

		// 	e.preventDefault();

		// 	checkScroll = true;
		// 	lightbox = false;
		// 	ticketsFrame = false;

		// 	$('#wrap').removeClass('sticked').css({
		// 		'top': 0
		// 	});
		// 	console.log(scrollTop);
		// 	$(window).scrollTop(scrollTop);

		// 	$('#lightbox_overlay_taf').stop().animate({
		// 		'opacity' : 0
		// 	}, 500, function() {
		// 		$(this).hide();
		// 	});
		// 	$('#lightbox_taf').animate({
		// 		'opacity' : 0
		// 	}, 500, function() {
		// 		$(this).hide();
		// 	});

		// });
	});
}


function colorbox() {
	$('.open-form').click(function(e) {
		e.preventDefault();
		if ($(this).data('id') == '')
			return false;

		if ( $('.prijs-calculator').is(':visible') ) {
			$('.prijs-calculator').hide();
		}

		scrollTop = $(window).scrollTop();
		checkScroll = false;
		lightbox = true;
		$('#wrap').addClass('sticked').css({
			'top' : scrollTop - (2 * scrollTop)
		});
		$('#lightbox_overlay').stop().show().animate({
			'opacity' : 1
		}, 500);

		var form_data = { 'id' : $(this).data('id') };

		if ( prijscalculator_filter !== false ) {
			form_data['filter'] = prijscalculator_filter.split('|');
		}

		$.ajax({
			url : js_object.template_dir + '/includes/ajax/' + $(this).data('href-form'),
			data : form_data
		}).done(function(data) {
			$('#lightbox .box').html(data);
			$('#lightbox').css({
				'top' : -2000
			}).show();
			$('#lightbox .inner').scrollTop(0);
			showPaymentFields();
			//colorbox();
			if ($(window).width() >= 768) {
				var height = $('.content.form').outerHeight(true);
				$('#lightbox').css({
					'top' : height - (2 * height),
					'opacity' : 1
				}).animate({
					'top' : 0
				}, 500);
			} else {
				$('#lightbox').css({
					'top' : 0,
					'opacity' : 0
				}).show().animate({
					'opacity' : 1
				}, 500);
			}
			$('.icon', '.content.form').each(function() {
				var box = this;
				if ($(this).data('id') != undefined) {
					var iconId = $(this).data('id');
					initIcon(box, iconId);
				}
			});
			$( '.datefield #day, .datefield #month' ).keyup(function() {
				if ( $( this ).val().length == 2 ) {
					$( this ).next( 'input' ).focus();
				}
			});
			last_dropdown = 'form';
			customDropdown();
			checkIbanRequired();
			submitForm();
		});
	})
	//$('#lightbox').on('click', '.close_lightbox_overlay, .close_btn', function() {
	$('#lightbox').on('click', '.close_btn', function() {
		checkScroll = true;
		lightbox = false;
		ticketsFrame = false;
		$('#wrap').removeClass('sticked').css({
			'top' : 0
		});
		$('body, html').scrollTop(scrollTop);
		$('#lightbox_overlay').stop().animate({
			'opacity' : 0
		}, 500, function() {
			$(this).hide();
		});
		if ($(window).width() >= 768) {
			var height = $('.content.form').outerHeight(true);
			$('#lightbox').stop().animate({
				'top' : height - (2 * height)
			}, 500, function() {
				$(this).hide();
			});
		} else {
			$('#lightbox').animate({
				'top' : 0,
				'opacity' : 0
			}, 500, function() {
				$(this).hide();
			});
		}
	});

}
var loaded_svgs = [];
var load_svgs = [];
var load_after = [];
var icon_array = [];
function initIcon(box, iconId) {
	if ( $( box ).data( 'icondone' ) == 'true' ) {
		return;
	}
	if (Modernizr.svg) {
		var prop = [];
		if ($(box).data('sprite') != undefined) {
			prop['sprite'] = $(box).data('sprite');
		} else {
			prop['sprite'] = js_object.template_dir + '/img/sprite.svg';
		}
		if ($(box).data('width') != undefined) {
			prop['width'] = $(box).data('width');
		} else {
			prop['width'] = 30;
		}
		if ($(box).data('height') != undefined) {
			prop['height'] = $(box).data('height');
		} else {
			prop['height'] = 30;
		}
		if ($(box).data('scale') != undefined) {
			prop['scale'] = $(box).data('scale');
		} else {
			prop['scale'] = 1.0;
		}
		if ($(box).data('color') != undefined) {
			prop['color'] = $(box).data('color');
		}
		if ($(box).data('opacity') != undefined) {
			prop['opacity'] = $(box).data('opacity');
		}
		if (iconId.substr(0, 5) != 'icon-') {
			iconId = 'icon-' + iconId;
		}
		// prop['$this'] = $(box);
		var boxClass = iconId.replace('icon-', 'icon-box-');
		var boxId = boxClass + '-' + ($('.' + boxClass).length + 1);
		prop['boxId'] = boxId;
		prop['iconId'] = iconId;
		$(box).html('<svg version="1.1" class="' + boxClass + '" id="' + boxId + '" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="0px" height="0px" viewBox="0 0 0 0" enable-background="new 0 0 0 0" xml:space="preserve">');
		//var s = Snap('#' + boxId);

		if ( typeof loaded_svgs[ prop['sprite'] ] != 'undefined' ) {
			showSVG( loaded_svgs[ prop['sprite'] ], prop );
		} else if ( load_svgs.indexOf( prop['sprite'] ) > -1 ) {
			if ( typeof load_after[ prop['sprite'] ] == 'undefined' ) {
				load_after[ prop['sprite'] ] = [];
			}
			load_after[ prop['sprite'] ].push( prop );
		} else {
			load_svgs.push( prop['sprite'] );
			if ( typeof load_after[ prop['sprite'] ] == 'undefined' ) {
				load_after[ prop['sprite'] ] = [];
			}
			load_after[ prop['sprite'] ].push( prop );
			Snap.load(prop['sprite'], function(data) {
				loaded_svgs[ prop['sprite'] ] = data;
				var icon_array = [];
				for ( var i = 0; i < load_after[ prop['sprite'] ].length; i++ ) {
					prop_a = load_after[ prop['sprite'] ][ i ];
					showSVG( data, prop_a )
				}
			});
		}
	} else {
		// IE8 of lager
		$(box).html('<div class="fallback-icon"></div>');
	}
}

function showSVG( data, prop ) {
	$('#' + prop['boxId']).parent().data('icondone', 'true');
	var s = Snap('#' + prop['boxId']);

	if ( typeof icon_array[ prop['iconId'] ] != 'undefined' ) {
		var g = icon_array[ prop['iconId'] ].clone();
	} else {
		var g = data.select('g#' + prop['iconId']);
		icon_array[ prop['iconId'] ] = g;
	}

	var pathBBox = g.select("path, polygon").getBBox();
	s.append(g);

	s.attr({
		viewBox : '0 0 ' + prop['width'] + ' ' + prop['height'],
		width : prop['width'] + 'px',
		height : prop['height'] + 'px',
		background : 'none',
	});
	/*
	 s.attr({
	 viewBox: '0 0 '+prop['width']+' '+prop['height'],
	 background: 'none',
	 });
	 */
	var resetX = Math.floor(pathBBox['x'] - (2 * pathBBox['x']) + ((prop['width'] - pathBBox['width']) / 2));
	var resetY = Math.floor(pathBBox['y'] - (2 * pathBBox['y']) + ((prop['height'] - pathBBox['height']) / 2));
	var scale = prop['height'] / pathBBox['height'];
	if (Math.floor(pathBBox['height']) / prop['height'] < Math.floor(pathBBox['width']) / prop['width']) {
		scale = prop['width'] / pathBBox['width'];
	}
	scale = scale * prop['scale'];
	scale = Math.floor(scale * 100) / 100;
	g.select("path, polygon").transform("t" + resetX + " ," + resetY);
	//var BBox = g.getBBox();
	//g.transform("s"+scale+","+scale+","+BBox.cx+","+BBox.cy);
	if (prop_a['color'] != undefined) {
		g.select("path, polygon").attr({
			fill : prop['color']
		});
	} else {
		g.select("path, polygon").attr({
			'fill' : ''
		});
	}
	if (prop_a['opacity'] != undefined) {
		g.select("path, polygon").attr({
			"fill-opacity" : prop['opacity']
		});
	}
}

function moveMobileNav() {
	// move top-nav to main-nav:
	$('ul', '.top-nav').appendTo($('.ul-content')).wrap('<div class="mobile-top-nav"></div>');
	// move phonenumber to main-nav:
	$('.tel', '.top-nav').appendTo($('.ul-content'));
	// remove search and replace:
	if ($('.mobile-search').length == 0 && $('li.search').length > 0) {
		$('<div class="mobile-search">' + $('li.search').html() + '</div>').prependTo('header nav');
	}
	// move subnav from detail pagina
	if ($('.detail').length > 0) {

		var themaClass = $('body').attr('class'),
			$aside = $('.detail aside'),
			$subNav = $aside.children('nav').children('ul');

		if (themaClass != ' default') {
			$('header nav ul ul').remove();
			$subNav.clone().appendTo($('header nav .ul-content ul li.' + themaClass));
			// $aside.remove();
			$aside.removeAttr('style');
		}
	}

	// init icons:
	setTimeout(function() {
		$('.icon', '.mobile-search').each(function() {
			var box = this;
			//console.log(box);
			if ($(this).data('id') != undefined) {
				var iconId = $(this).data('id');
				initIcon(box, iconId);
			}
		});

		$('.icon', '.input-search').each(function() {
			var box = this;
			if ($(this).data('id') != undefined) {
				var iconId = $(this).data('id');
				initIcon(box, iconId);
			}
		});
	},100);

}

function moveBackMobileNav() {
	//console.log('2');
	// move top-nav back
	$('.mobile-top-nav ul').appendTo($('.top-nav'));
	$('.mobile-top-nav').remove();
	// move phonenumber back
	$('.tel', '.ul-content').appendTo($('.top-nav'));
	// move search:
	$('.mobile-search').remove();
	// move subnav detail page:
	$('header nav ul ul').remove();
	if ($('.detail').length > 0) {
		var themaClass = $('body').attr('class'),
			$aside = "<aside></aside>",
			$nav = "<nav></nav>";

		if (themaClass != ' default' && themaClass.trim() != '' ) {

			var $subNav = $('header nav .ul-content ul li.' + themaClass + ' ul');

			if ($('.detail .top .center aside').length == 0 && $subNav.length > 0) {
				// $('.detail .top .center').prepend($aside);
				// $('.detail .top .center aside').append($nav);
				// $('.detail .top .center aside nav').append($subNav);
			}
		}
	}
}


function openCloseMobileNav() {
	var $nav = $('header nav');
	$nav.off('click', '.mobile-nav-icon .icon-hamburger, .mobile-nav-icon .icon-close');
	$nav.on('click', '.mobile-nav-icon .icon-hamburger, .mobile-nav-icon .icon-close', function(e) {
		e.preventDefault();
		var $this = $('.mobile-nav-icon .icon-hamburger'),
			$mobileScroll = $nav.find('.mob-scroll'),
			$mobileScrollInner = $nav.find('.mob-scroll-inner'),
			$ulContent = $mobileScroll.find('.ul-content'),
			height1 = $(window).height() - 90,
			heightInner = $ulContent.children('ul').height() + $ulContent.children('.mobile-top-nav').height() + $ulContent.children('.tel').height();

		// give ul.content height
		$ulContent.height(heightInner);

		if ($this.hasClass('open')) {
			$this.removeClass('open');
			$('.mobile-nav-icon .icon-close').removeClass('show');
			$ulContent.addClass('slide-up').removeClass('slide-down').removeAttr('style');
			$mobileScroll.removeAttr('style');
		} else {
			$this.addClass('open');
			$('.mobile-nav-icon .icon-close').addClass('show');
			$ulContent.addClass('slide-down').removeClass('slide-up');
			$mobileScroll.css('height', height1);
		}
	});
}

function filterList(e, o, d) {
	e.attr('data-orderby', o);
	e.attr('data-order', d);
	e.find('.item').sort(function(a, b) {
		if (d == 'DESC')
			return (b.getAttribute('data-' + o)) > (a.getAttribute('data-' + o)) ? 1 : -1;
		else
			return (b.getAttribute('data-' + o)) < (a.getAttribute('data-' + o)) ? 1 : -1;
	}).appendTo(e);
}

function customDropdown() {
	// dropdown select inputs
	//console.log(last_dropdown);
	$('.content').on('click', '.field.select:not(.disabled)', function() {
		if (!$(this).hasClass('focus')) {
			if ($('.select.focus').length != '') {
				$('.select.focus').click();
			}
			$('.select ul.dropdown li').removeClass('select');
			$(this).addClass('focus');
		} else {
			$(this).removeClass('focus');
		}
		filterList($('.items'), $('.sort .dropdown .active').data('orderby'), ($('.sort .dropdown .active').is('.op') ? 'ASC' : 'DESC'));
	});
	$('body').click(function(e) {
		if ($('.select').hasClass('focus')) {
			if (e.target.className.indexOf('select-ex') == -1) {
				$('.select.focus').removeClass('focus');
			}
		}
	});
	$('.content').on('click', '.field.select ul.dropdown li:not(.disabled)', function() {
		if (!$(this).hasClass('active')) {
			$('.select ul.dropdown li').removeClass('active');
			$(this).addClass('active');
			if ($(this).data('value') == '') {
				$(this).closest('.select').find('input').attr('value', '');
				$(this).closest('.select').find('input').val('');
				$(this).closest('.select').find('.text').text('');
			} else {
				$(this).closest('.select').find('input').attr('value', $(this).data('value'));
				$(this).closest('.select').find('input').val($(this).data('value'));
			}

			if ( $(this).hasClass( 'movie_date' ) ) {
				do_movie_date_change( $(this).data('date') );
			}
			if ( $(this).hasClass( 'movie_time' ) ) {
				do_movie_time_change( $(this).data('location'), $(this).data('url') );
			}

			//console.log( $(this).parents('.prijs-calculator').length );

			// input = div
			if ($(this).attr('class').indexOf('op') > 0) {
				var extraClass = 'op';
				var removedClass = 'af';
			} else if ($(this).attr('class').indexOf('af') > 0) {
				var extraClass = 'af';
				var removedClass = 'op';
			} else if ($(this).parents('.prijs-calculator').length > 0 || $(this).parents('.film-filter').length > 0) {
				var extraClass = 'choice';
			}

			if ('undefined' != typeof $(this).data('label') && $(this).data('label') !== '') {
				$(this).closest('.select').find('.input').text($(this).data('label')).addClass(extraClass).removeClass(removedClass);
				$(this).closest('.select').find('input').text($(this).data('label')).addClass(extraClass);
				$(this).closest('.select').find('.text').text($(this).data('label'));
			} else {
				$(this).closest('.select').find('.input').text($(this).data('value')).addClass(extraClass).removeClass(removedClass);
				$(this).closest('.select').find('input').text($(this).data('value')).addClass(extraClass);
				$(this).closest('.select').find('.text').text($(this).data('value'));
			}
			$(this).closest('.select').find('input').trigger('change');
			if ($(this).attr('class').indexOf('az') > 0) {
				$(this).closest('.select').find('.input').addClass('az');
			} else {
				$(this).closest('.select').find('.input').removeClass('az');
			}
		}
	});
	$(document).keydown(function(e) {
		if ($('.field.select').hasClass('focus')) {
			e.preventDefault();
			var code = (e.keyCode ? e.keyCode : e.which);
			if (code == 40) {
				var total = $('.select.focus ul.dropdown li').size() - 1;
				var current = 0;
				if ($('.select.focus ul.dropdown li.select').length != '') {
					current = $('.select.focus ul.dropdown li.select').index() + 1;
				}
				if ($('.select.focus ul.dropdown li').eq(current).hasClass('active')) {
					current++;
				}
				if (current > total) {
					current = 0;
				}
				if ($('.select.focus ul.dropdown li').eq(current).hasClass('active')) {
					current++;
				}
				$('.select.focus ul.dropdown li').removeClass('select');
				$('.select.focus ul.dropdown li').eq(current).addClass('select');
			} else if (code == 38) {
				var total = $('.select.focus ul.dropdown li').size() - 1;
				var current = total;
				if ($('.select.focus ul.dropdown li.select').length != '') {
					current = $('.select.focus ul.dropdown li.select').index() - 1;
				}
				if ($('.select.focus ul.dropdown li').eq(current).hasClass('active')) {
					current--;
				}
				if (current < 0) {
					current = total;
				}
				if ($('.select.focus ul.dropdown li').eq(current).hasClass('active')) {
					current--;
				}
				$('.select.focus ul.dropdown li').removeClass('select');
				$('.select.focus ul.dropdown li').eq(current).addClass('select');
			} else if (code == 13) {
				$('.select.focus input').attr('value', $('.select.focus ul.dropdown li.select').data('value'));
				$('.select.focus input').trigger('change');
				$('.select.focus').removeClass('focus');
			} else if (code == 27) {
				$('.select.focus').removeClass('focus');
			}
		}
	});
}

function do_movie_date_change( date ) {
	var $selected_date = $( '.film-filter .tijd.select .dropdown li[data-date="' + date + '"]' );
	$selected_date.removeClass( 'hidden' );

	$( '.film-filter .tijd.select .dropdown li' ).addClass( 'hidden' );
	$( '.film-filter .tijd.select input[name="tijd"]' ).removeClass( 'choice' );
	$( '.film-filter .tijd.select input[name="tijd"]' ).val( 'selecteer een tijd' );

	if ( 'undefined' != typeof date ) {
		$selected_date.removeClass( 'hidden' );

		if ( $selected_date.length == 1 ) {
			$selected_date.closest('.movie_time').addClass('choice');
			$selected_date.closest('.movie_time').trigger('click');
		}
	}
}

function do_movie_time_change( location, url ) {
	$( '.location_str' ).html( '<label>zaal:</label>' + location );
	if ( '' == url ) {
		url = '#';
	}
	$( '.s_ticket_button' ).attr( 'data-href', url );
}

function prijsCalculator() {

	$('.calc a', '.info-block').each(function() {

		var $calc = $(this);
		$.ajax({
			type : 'POST',
			url : js_object.ajax_url,
			data : {
				'action' : 'form-calculator',
				'id' : $calc.data('id'),
				'discipline' : $calc.data('discipline'),
				'filter' : ($calc.parent().find('form').length > 0 ? $calc.parent().find('form').serialize() : ''),
			},
			success : function(data) {

				var obj = JSON.parse(data);

				if (obj.html != '') {

					$calc.parent().show();
					$.when($calc.after(obj.html)).then(function() {
						$('.icon', $calc.parent().find('form')).each(function() {
							var box = this;
							if ($(this).data('id') != undefined) {
								var iconId = $(this).data('id');
								initIcon(box, iconId);
							}
						});

						var $prijsCalc = $calc.parent().find('form'), $overlay = $('.prijs-calculator-overlay');

						// close calculator:
						$('.prijs-calculator').on('click', 'span.title', function(e) {
							e.preventDefault();
							$prijsCalc.fadeOut();
							$overlay.fadeOut();
						});
						$overlay.on('click', function() {
							$prijsCalc.fadeOut();
							$overlay.fadeOut();
						});
						// open calculator:

						var $dropdowns = $prijsCalc.find('.dropdown');
						$(this).on('click', function(e) {

							if ( 'init' != last_dropdown ) {
								last_dropdown = 'init';
								customDropdown();
							}

							//START - check if single options
							var $c = 0;

							$.when($dropdowns.each(function() {
								if ($(this).find('li:gt(0)').length == 1)
									$(this).closest('.field').addClass('disabled').find('.cont input').addClass('choice').val($(this).find('li:eq(1)').addClass('active').data('value')).closest('.cont').find('.btn').hide();
							})).then(function() {
								//if($c==$dropdowns.length)
								$('input', '.calc form').trigger('change');
							});

							// END - check

							e.preventDefault();
							$prijsCalc.fadeIn();
							$overlay.fadeIn();
						});

						$prijsCalc.find('.reset').on('click', function() {
							$(this).closest('.fields').find('.dropdown').each(function(){
								if($(this).find('li:gt(0)').length>1)
								{
									$(this).find('li').removeClass('active').removeClass('disabled');
									$(this).closest('.field').find('input[type="text"]').prop('value','');
								}
							});
							$prijsCalc.find('.checkbox input[type="checkbox"]').prop('checked',false);

							$('input', '.calc form').trigger('change');
						});


						$prijsCalc.find('.price a').on('click', function(e) {
							e.preventDefault();
							prijscalculator_filter = $(this).closest('.current').data('combo');
							$prijsCalc.hide();
							$('button.open-form').trigger('click');
						});

						$('input', '.calc form').each(function() {
							$(this).change(function() {

								prijsCalculatorUpdate( function() { // NOTE: callback functie toegevoegd

									var data = $calc.parent().find('form input[type="text"]').map(function() {
										return $(this).prop('value');
									}).get().join('|');

									data += '|' + ($calc.parent().find('form input[name="price_unlimited"]:checked').length > 0 ? '1' : '2');
									data += '|' + ($calc.parent().find('form input[name="price_discount"]:checked').length > 0 ? 'on' : '');

									// NOTE: nieuwe radio buttons 'leeftijd'
									if ( $prijsCalc.find('.field.leeftijd input:checked').length > 0 ) {
										data = $prijsCalc.find('.field.leeftijd input:checked').val() + '|' + data;
									}

									if ($prijsCalc.find('.results .price.default.current').length == 0) {
										$prijsCalc.find('.results').toggleClass('animating');
										$prijsCalc.find('.results').removeClass('show_price');
										prijscalculator_filter = false;
										setTimeout(function() {
											$prijsCalc.find('.results .price').removeClass('current').closest('.results').find('.default').addClass('current');
											$prijsCalc.find('.results').toggleClass('animating');
										}, 500);
									}
									$prijsCalc.find('.results .price').each(function() {
										if ($(this).data('combo') == data) {
											var $this = $(this);
											$prijsCalc.find('.results').toggleClass('animating');
											setTimeout(function() {
												$this.toggleClass('current').siblings().removeClass('current');
												$this.closest('.results').addClass('show_price')
												$prijsCalc.find('.results').toggleClass('animating');
											}, 500);
										}

									});

								});

							});
						});
					});
				} else {
					$calc.parent().remove();
				}
			}
		});
	});

}

function prijsCalculatorUpdate( callback ) {

	if ( ! submitting ) {

		submitting = true;

		var $calc = $('.calc', '.info-block'),
			$formdata = $calc.find('form').length > 0 ? $calc.find('form').serialize() : '';

		// change `%20` to `+`
		$formdata = $formdata.replace(/\%20/g, '+');

		$.ajax({
			type : 'POST',
			url : js_object.ajax_url,
			data : {
				'action' : 'form-calculator',
				'id' : $calc.find('a').data('id'),
				'discipline' : $calc.find('a').data('discipline'),
				'filter' : $formdata,
			},
			success : function(data) {

				var run_again = false;

				var obj = JSON.parse(data);

				if (obj.html != '') {

					$calc.find('.dropdown li').removeClass('disabled');
					$calc.find('#course-discount').removeClass('disabled');
					$calc.find('#course-discount input[type="checkbox"]').prop('disabled', false);
					$calc.find('input[type="text"]').each(function() {
						//if(!$(this).val())
						//{
						var field = $(this).attr('name');
						$(this).closest('.field').find('.dropdown li:gt(0)').each(function() {
							if (obj.html[field].indexOf($(this).data('value').toString()) < 0)
								$(this).addClass('disabled');
						});

						if( $(this).closest('.field').find('.dropdown li[data-value!=""]:not(.disabled)').length == 1 ) {
							var $dropdown_li = $(this).closest('.field').find('.dropdown li[data-value!=""]:not(.disabled)');
							var $value = $dropdown_li.data('value').toString().split(' ').join('+');
							var $string = field + '=' + $value;
							if ( $formdata.indexOf( $string ) == -1 ) {
								$dropdown_li.addClass('active');
								$(this).val( $dropdown_li.data('value') ).addClass('choice');
								run_again = true;
							}
						}
						//}
					});
					if ( 'undefined' != typeof obj.html['price_discount'] ) {
						if ( Object.keys( obj.html['price_discount'] ).length == 1 ) {
							if ( obj.html['price_discount'][0] != null && '' == obj.html['price_discount'][0].toString() ) {
								$calc.find('#course-discount').addClass('disabled');
								$calc.find('#course-discount input[type="checkbox"]').prop('disabled', true);
								$calc.find('#course-discount input[type="checkbox"]').prop('checked', false);
							}
						}
					}
				}

				submitting = false;

				if ( run_again ) {
					//console.log('run again');
					prijsCalculatorUpdate( callback );
				} else {
					callback();
				}
			}
		});
	}
}

function themaNav() {

	var $themaNav = $('.thema-nav');

	// close all themas
	$themaNav.find('.thema').each(function() {
		$(this).find('.th-content').hide();
	});

	// open uitgelicht thema
	$themaNav.find('.thema.uitgelicht').addClass('open').find('.th-content').show();

	// when click on closed thema
	$themaNav.on('click', '.thema h4', function() {

		var $thema = $(this).parent('.thema');

		if (!$thema.hasClass('open')) {
			$themaNav.find('.thema.open').removeClass('open').find('.th-content').slideUp('slow');
			$thema.addClass('open').find('.th-content').slideDown();
		}

	});
}

function submitForm() {
	$('.content.form').on('click', 'input[type="submit"]', function(e) {
		e.preventDefault();
		// check error class
		if (!submitting) {
			submitting = true;
			$('.content.form input,.content.form textarea,.content.form div,.content.form label').removeClass('error-style');
			$.ajax({
				type : 'POST',
				url : js_object.ajax_url,
				data : $(this).closest('form').serialize(),
				success : function(data) {
					submitting = false;
					if (data === true) {

					} else {
						var obj = JSON.parse(data);
						if (obj.errors) {
							for (field in obj.errors) {
								$('.content.form input[name="' + obj.errors[field] + '"],.content.form div[id="' + obj.errors[field] + '"],.content.form textarea[name="' + obj.errors[field] + '"],.content.form label[for="' + obj.errors[field] + '"]').addClass('error-style');
							}
							$('.content.form div.submit').prepend('<div class="message error-style">mislukt, controleer het formulier!</div>').find('.message').animate({
								'opacity' : '1'
							}, 500, function() {
								setTimeout(function() {
									$('.content.form .submit .message').animate({
										'opacity' : '0'
									}, 500, function() {
										$(this).remove();
									});
								}, 2500);
							});
							$( '#lightbox .inner' ).animate({
								scrollTop: $( '.error-style' ).first().offset().top - $( '.content.form' ).offset().top - 30
							}, 1000, function() {
								$( '.error-style' ).first().focus();
							});
						} else if (data == 'true') {

							let cursus_form = document.getElementById('cursus-inschrijven');
							let proefles_form = document.getElementById('cursus-proefles');
							if ( cursus_form ) {
								let cursus_form_name = cursus_form.querySelector("input[name='course_name']").value;
								window.dataLayer = window.dataLayer || [];
								dataLayer.push({
									'event': 'aanmeldingCursus',
									'course': cursus_form_name
								});
							} else if ( proefles_form ) {
								let cursus_form_name = proefles_form.querySelector("input[name='cursus']").value;
								window.dataLayer = window.dataLayer || [];
								dataLayer.push({
									'event': 'aanmeldingProefles',
									'course': cursus_form_name
								});
							}

							$('.content.form .submit').html('<div class="message">succesvol verzonden!</div>').find('.message').animate({
								'opacity' : '1'
							}, 500, function() {
								setTimeout(function() {
									$('#lightbox .close_btn').trigger('click');
								}, 1500);
							});
						}
					}
				},
				error : function(e) {
					submitting = false;
					//
				}
			});
		}
	});
}

// function openTicketsMobile(url) {
// 	url = url.replace('/tickets/', '/tickets-mobile/')
// 	window.location = url;
// }

function switchTickets() {
	if ($('#ticket-frame').length != '' && $(window).width() < 1024) {
		var url = window.location.href
		url = url.replace('/tickets/', '/tickets-mobile/')
		window.location = url;
	} else {
		return false;
	}
}

function sortTicketButtons() {

	if ( $('.items.list .item-film').length > 0 ) {
		var $order = 'desc';
		if ( $('html.mobile').length > 0 ) {
			$order = 'asc';
		}

		$('.items.list .item-film').each(function(){
			var $wrapper = $(this).find('.info');
			if ( $wrapper.find('.tickets-ex:gt(0)').length > 0 ) {
				$wrapper.find('.tickets-ex').sort(function (a, b) {
					if ( 'undefined' != typeof $order && 'asc' == $order ) {
			   		return $(a).attr('data-time') - $(b).attr('data-time');
					} else {
						return $(b).attr('data-time') - $(a).attr('data-time');
					}
				})
				.prependTo( $wrapper );
			}
		});
	}
}

var player, yt_loaded = false, yt_check;

function init_youtube( container ) {
	setTimeout(function() {
		var player_id = container.attr('id');

		player = new YT.Player( player_id , {
			playerVars: {
				'autoplay': 1,
				'showinfo': 0,
				'controls': 0
			},
			events: {
				'onReady': onYouTubePlayerReady,
				'onStateChange' : onPlayerStateChange,
			},
			videoId: container.data('id'),
		});
	},750);
}

function onYouTubePlayerReady( event ) {
	var start = $( event.target.a ).data('seek');
	player.seekTo( start );
	player.mute();
}

function onYouTubePlayerAPIReady() {
	if( yt_loaded === false ) {
		yt_loaded = true;
		//this was moved to the Eagerly cookie notice plugin
		// if( $('div[id*="player_"]').length > 0 ) {
		// 	$('div[id*="player_"]').each( function(){
		// 		init_youtube( $(this) );
		// 	});
		// }
	}
}

function onPlayerStateChange( event ){
	if( typeof event.data != 'undefined' && event.data == 0 ) {
		var start = $( event.target.a ).data('seek');
		player.seekTo( start );
		player.mute();
	}
}

$(function() {

	// klap filter uit bij cursussen if in URL 'toonfilter=true'
	if ( 'undefined' != typeof URLSearchParams ) {
		var urlParams = new URLSearchParams(window.location.search);
		if ( urlParams.has('toon_filter') ) {
			$(window).on('load', function() {
				$( '.filter button ').click();

			});
		}
	}

	yt_check = setInterval(function(){
		if( yt_loaded === false && typeof YT != 'undefined' ) {
			onYouTubePlayerAPIReady();
			//console.log('YT API manual');
			clearInterval( yt_check );
		}
	},750);

	var touchScreen = false;
	if ($('html').hasClass('touch')) {
		touchScreen = true;
	}
	var rgba = true;
	if ($('html').hasClass('no-rgba')) {
		rgba = false;
	}

	if ( $( 'body' ).hasClass( 'welzijn' ) && $( 'header nav .menu li.current-menu-item' ).length == 0 ) {
		$( 'header nav .menu li.welzijn' ).addClass( 'current-menu-item' );
	} else if ( $( 'body' ).hasClass( 'cursussen' ) && $( 'header nav .menu li.current-menu-item' ).length == 0 ) {
		$( 'header nav .menu li.cursussen' ).addClass( 'current-menu-item' );
	} else if ( $( 'body' ).hasClass( 'zakelijk' ) && $( 'header nav .menu li.current-menu-item' ).length == 0 ) {
		$( 'header nav .menu li.zakelijk' ).addClass( 'current-menu-item' );
	} else if ( $( 'body' ).hasClass( 'scholen' ) && $( 'header nav .menu li.current-menu-item' ).length == 0 ) {
		$( 'header nav .menu li.scholen' ).addClass( 'current-menu-item' );
	} else if ( $( 'body' ).hasClass( 'activiteiten' ) && $( 'header nav .menu li.theater.current-menu-item' ).length > 0 ) {
		$( 'header nav .menu li.theater' ).removeClass( 'current-menu-item' );
	}

	if ( $( 'body.welzijn .overzicht .results.content .total span' ).length > 0 ) {
		//$( 'body.welzijn .overzicht .results.content .total span' ).html( $( 'body.welzijn .overzicht .results.content .items a.item' ).length );
		$( 'body.welzijn .overzicht .results.content .items a.item:nth-child(3n+1)' ).addClass( 'first-welzijn-item' );
	}

	if ( $( 'body.film .overzicht .results.content .total span' ).length > 0 ) {
		$( 'body.film .overzicht .results.content .total span' ).html( $( 'body.film .overzicht .results.content .items a.item' ).length );
		$( 'body.film .overzicht .results.content .items a.item:nth-child(4n+1)' ).addClass( 'first-film-item' );
	}

	if ( $( 'body.default .film .overzicht .results.content .total span' ).length > 0 ) {
		$( 'body.default .film .overzicht .results.content .items a.item:nth-child(4n+1)' ).addClass( 'first-film-item' );
	}

	if ( $( 'body.theater .overzicht .results.content .total span' ).length > 0 ) {
		$( 'body.theater .overzicht .results.content .items a.item:nth-child(3n-2)' ).addClass( 'first-theater-item' );
	}

	// switch grid / resize functions
	$(window).scroll(function() {
		//if (!Modernizr.touch) {
		var pos = $(window).scrollTop();

		// [DESKTOP && TABLET landscape]
		if (Modernizr.mq('(min-width: 1024px)')) {
			positionBgImg();
		}

		// [DESKTOP && TABLET]
		if (Modernizr.mq('(min-width: 768px)')) {
			makeAsideSticky();
		}

		//}
	});

	var firstGrid = true;
	switchGridFuncs = function(grid) {
		if (firstGrid == true) {
			firstGrid = false;
			var pos = $(window).scrollTop();

			//helperFunctionSliced();
			switchView();
			openTopNav();
			openCloseFilter();
			selectTheaterFilter();
			selectWelzijnFilter();
			selectFilmFilter();
			//moreInfo();
			showPaymentFields();
			checkIbanRequired();
			owl();
			colorbox();
			last_dropdown = 'init';
			customDropdown();
			prijsCalculator();
			themaNav();
			submitForm();
			selectFilterButton();
			resizeHero();
			tellafriend();
			newsletter_subscribe();
			share();
			sortTicketButtons();

			// [DESKTOP && TABLET landscape]
			//if ($('html').hasClass('desktop') || $('html').hasClass('landscape')) {
			if (Modernizr.mq('(min-width: 1024px)')) {
				positionBgImg();
				themaLabels();
				hero();
			}
			// [DESKTOP && TABLET]
			//if ($('html').hasClass('desktop') || $('html').hasClass('tablet')) {
			if (Modernizr.mq('(min-width: 768px)')) {
				openSearchFilter();
				moveBackMobileNav();
				openSearchFilter();
				openSearchMenu();
				makeAsideSticky();
			}
			// [MOBILE]
			if (Modernizr.mq('(max-width: 767px)')) {
				moveMobileNav();
				openCloseMobileNav();
				openSearchMenuMobile();
			}

		} else {
			switchTickets();
			sortTicketButtons();
		}

	}
	var resizeTimeout;
	$(window).resize(function() {
		resizeTimeout = setTimeout(function() {

			// [DESKTOP]
			if (Modernizr.mq('(min-width: 1024px)')) {
				hero();
			}

			// [DESKTOP && TABLET]
			//if ($('html').hasClass('desktop') || $('html').hasClass('tablet')) {
			if (Modernizr.mq('(min-width: 768px)')) {
				openSearchFilter();
				moveBackMobileNav();
				themaLabels();
				openSearchMenu();
			}
			// [MOBILE]
			if (Modernizr.mq('(max-width: 767px)')) {
				moveMobileNav();
				openCloseMobileNav();
				openSearchMenuMobile();
			}

		}, 100);
	});

	// [Buttons & info]
	$('[data-href]').click(function(e) {
		var target = $(e.target);
		if (target.not('a') && !target.parent('a').length) {
			// if ($(this).hasClass('tickets-ex') && $(window).width() < 1024) {
			var url = $(this).attr('data-href');
			if ( '' != url && '#' != url ) {
				// 	openTicketsMobile(url);
				// } else {
				if ($(this).attr('data-window') == 'new') {
					window.open( url );
				} else {
					//if (target.parents('a.closed').length == 0 ) {
					window.location.href = url;
					//}
				}
			} else {
				e.preventDefault();
			}
			// }
			return false;
		}
	});

	if ( $('.items.list a[id*="theater-"]').length > 0 ) {

		if (window.location.hash) {
			 if (window.location.hash.indexOf('theater-') > -1) {
				 var elem = $('.items.list ' + window.location.hash );
				 if ( typeof elem.position() != 'undefined' ) {
					 setTimeout(function(){
						 $('html, body').animate({
		            scrollTop: elem.position().top + 'px'
		      	 }, 'fast');
					 },1000);
				 }
			 }
		}

		$('.items.list a[id*="theater-"]').click(function(e){
			// push history state w/hashtag
			window.history.replaceState( {} , document.title, '#' + $(this).attr('id') );
		});
	}

	$('.theater .aanmelden button, .film .aanmelden button, .theater .aanmelden .button, .film .aanmelden .button').click(function(e) {
		e.preventDefault();
		// if ($(window).width() < 1024) {
		// 	e.preventDefault();
		// 	var url = $(this).attr('data-href');
		// 	openTicketsMobile(url);
		// }
	});

	// [placeholder]
	if (!Modernizr.input.placeholder) {
		$('[placeholder]').focus(function() {
			var input = $(this);
			if (input.val() == input.attr('placeholder')) {
				input.val('');
				input.removeClass('ph');
			}
		}).blur(function() {
			var input = $(this);
			if (input.val() == '' || input.val() == input.attr('placeholder')) {
				input.addClass('ph');
				input.val(input.attr('placeholder'));
			}
		}).blur();
		$('[placeholder]').parents('form').submit(function() {
			$(this).find('[placeholder]').each(function() {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
				}
			});
		});
	}

	// [icons]
	$('.icon').each(function() {
		var box = this;
		if ($(this).data('id') != undefined) {
			var iconId = $(this).data('id');
			initIcon(box, iconId);
		}
	});

	// [lightbox]
	$('#lightbox-close').click(lightbox.close);

	$('.photo-thumb').click(function(e){
		// check if not responsive smallest
		if (Modernizr.mq('(max-width: 767px)')) {
			e.preventDefault();
		} else {
			var photos = [];

			$('.photo-thumb').each(function(){
				photos.push({
					url: $(this).attr('href'),
					photographer: {
						name: $(this).data('photographer-name'),
						url: $(this).data('photographer-url')
					}
				});
			});

			lightbox.init( photos );
			lightbox.show( ($(this).index()+1) );
			return false;
		}
	});

	$('#lightbox-photos').on('click', '#lightbox-slides > li', function(e){
		e.stopPropagation();

		$(this).parent().children().removeClass('active');
		$(this).addClass('active');

		$('#lightbox-info-counter .current').html( $(this).index()+1 );
		if ( $(this).data('photographer-url') ) {
			$('#lightbox-info-photographer').html( 'fotograaf: <a href="' + $(this).data('photographer-url') + '" target="_blank">' + $(this).data('photographer-name') + '</a>' );
		} else if ( typeof $(this).data('photographer-name') != 'undefined' ) {
			$('#lightbox-info-photographer').html( 'fotograaf: ' + $(this).data('photographer-name') );
		}

		var slideWidth = $(this).width();
		var lightboxWidth = $('#lightbox-slides-wrap').width();
		var index = $(this).index();
		var margin = ( lightboxWidth - slideWidth ) / 2;

		$('#lightbox-slides').css({
			'transform': 'translateX(' + (margin + (index) * slideWidth * -1 ) + 'px)'
		});
	});

	$('#lightbox-wrap-bg, #lightbox-info').click(function(){
		lightbox.close();
	});

	$('#lightbox-arrows #lightbox-next').click(function() {
		$('#lightbox-slides > li.active').next('li').trigger('click');
	});

	$('#lightbox-arrows #lightbox-prev').click(function() {
		$('#lightbox-slides > li.active').prev('li').trigger('click');
	});

	$(window).resize(function() {
		if ($('#lightbox-wrap').hasClass('visible')) {
			if ($(window).width() >= 768) {
				var top = ( ( ( $(window).height() - $('#topbar').height() ) - $('#lightbox-photos').height() ) / 2 ) + $('#topbar').height();
				if (top < $('#topbar').height() + 60) { top = $('#topbar').height() + 60; }
				$('#lightbox-photos').css({'top' : top});
				$('#lightbox-slides li.active').click();
			} else {
				lightbox.close();
			}
		}
	});

	$(document).on('keyup', function(e){
		if ($('#lightbox-wrap').hasClass('visible')) {
			e.preventDefault();
			if( e.keyCode == 39 ) { // right
				$('#lightbox-slides > li.active').next('li').trigger('click');
			} else if( e.keyCode == 37 ) { // left
				$('#lightbox-slides > li.active').prev('li').trigger('click');
			} else if( e.keyCode == 27 ) { // esc
				lightbox.close();
			}
		}
	});

	$('#lightbox-wrap').swipe({
		swipeLeft: function(){
			if( !$('#lightbox-wrap').hasClass('visible') ) return false;
			$('#lightbox-slides > li.active').next('li').trigger('click');
		},
		swipeRight: function(){
			if( !$('#lightbox-wrap').hasClass('visible') ) return false;
			$('#lightbox-slides > li.active').prev('li').trigger('click');
		}
	});

	if ($('#cookie').length != '') {
		setTimeout(function() {
			$('#cookie').addClass('show');
		}, 3000);
		$('#cookie button').click(function() {
			$('#cookie').removeClass('show');
			var date = new Date();
			date.setTime(date.getTime()+(50*24*60*60*1000));
			var expires = "; expires="+date.toGMTString();
			document.cookie = 'cookie=yes'+expires+'; path=/'
		});
	}

	var hasnlc = false;
	if ( document.cookie.indexOf( '; newsletter=' ) > -1 ) {
		hasnlc = true;
	} else if ( document.cookie.indexOf( 'newsletter=' ) == 0 ) {
		hasnlc = true;
	}
	if ( !hasnlc ) {
		//var date = new Date();
		//date.setTime(date.getTime()+(50*24*60*60*1000));
		//var expires = "; expires="+date.toGMTString();
		setTimeout(function () {
			document.cookie = 'newsletter=yes; path=/';
			$( '.newsletter-message' ).css( { opacity: 0, display: 'block' } ).animate( { opacity: 1 } );
			$( '.newsletter-message' ).click( function() { $( this ).hide(); $( '.newsletter-subscribe-btn' ).click(); } );
		}, 3000);
	}
});

function checkOpenCourseFilter() {
	if ( typeof $( '.filter-slided-down .discipline' ).data( 'active' ) != 'undefined' && $( '.filter-slided-down .discipline a[data-term_name="' + $( '.filter-slided-down .discipline' ).data( 'active' ) + '"]' ).length > 0 ) {
		$('.filter button', '.overzicht').click();

		setTimeout(function() {
			$( '.filter-slided-down .discipline a[data-term_name="' + $( '.filter-slided-down .discipline' ).data( 'active' ) + '"]' ).click();
		}, 500);
	}
}

var grid = 0;
var currentGrid = 0;
var setGrid = function() {
	if (Modernizr.mq('(max-width: 767px)')) {
		grid = 'mobile';
	} else if (Modernizr.mq('(max-width: 1139px)')) {
		grid = 'tablet';
		if (Modernizr.mq('(max-width: 1023px)')) {
			grid += ' portrait';
		} else {
			grid += ' landscape';
		}
	} else {
		grid = 'desktop';
		if (Modernizr.mq('(min-width: 1460px)')) {
			grid += ' wide';
		}
	}

	if ($('html').hasClass('no-borderradius')) {
		grid += ' IE8';
	}
	if (grid != currentGrid) {
		var gridClasses = ['mobile', 'tablet', 'desktop', 'portrait', 'landscape', 'wide', 'IE8'];
		$.each(gridClasses, function(i, v) {
			$('html').removeClass(v);
		})
		var newClass = grid;
		$('html').addClass(newClass);
		currentGrid = grid;
		switchGridFuncs(newClass)
	}
}
$(function() {
	$(window).resize(function() {
		setGrid();
	});
});
$('#setGrid').ready(function() {
	setGrid();
});

